/**
 * Dose Blog Posts List Custom - Handles category tab filtering for blog articles
 */

class DoseBlogCustomFilter {
  constructor(sectionElement) {
    this.container = sectionElement || document;
    this.tabs = this.container.querySelectorAll('.dose-blog-tab');
    this.blogGroups = this.container.querySelectorAll('.dose-blog-group');
    this.activeTab = 'all';

    this.init();
  }

  init() {
    if (!this.tabs.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => this.handleTabClick(e));
    });
  }

  handleTabClick(event) {
    const clickedTab = event.currentTarget;
    const tabValue = clickedTab.getAttribute('data-tab');

    if (this.activeTab === tabValue) return;

    this.activeTab = tabValue;
    this.updateTabs(clickedTab);
    this.filterBlogs(tabValue);
  }

  updateTabs(activeTab) {
    this.tabs.forEach((tab) => {
      tab.classList.remove('dose-blog-tab--active');
      tab.setAttribute('aria-pressed', 'false');
    });

    activeTab.classList.add('dose-blog-tab--active');
    activeTab.setAttribute('aria-pressed', 'true');
  }

  filterBlogs(tabValue) {
    this.blogGroups.forEach((group) => {
      const blogHandle = group.getAttribute('data-blog');

      if (tabValue === 'all' || blogHandle === tabValue) {
        this.fadeIn(group);
      } else {
        this.fadeOut(group);
      }
    });
  }

  fadeIn(element) {
    element.style.opacity = '0';
    element.style.display = 'block';

    setTimeout(() => {
      element.style.transition = 'opacity 300ms ease-in-out';
      element.style.opacity = '1';
    }, 10);
  }

  fadeOut(element) {
    element.style.transition = 'opacity 300ms ease-in-out';
    element.style.opacity = '0';

    setTimeout(() => {
      element.style.display = 'none';
    }, 300);
  }
}

function initDoseBlogFilters() {
  const sections = document.querySelectorAll('.dose-section-blog-custom');
  if (sections.length > 0) {
    sections.forEach((section) => new DoseBlogCustomFilter(section));
  } else {
    new DoseBlogCustomFilter();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDoseBlogFilters);
} else {
  initDoseBlogFilters();
}

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target && event.target.classList.contains('dose-section-blog-custom')) {
      new DoseBlogCustomFilter(event.target);
    } else {
      initDoseBlogFilters();
    }
  });
}
